import { useState, useEffect, useContext } from "react";
import UserContext from "../Authcontext";
import axios from "axios";
import { API_BASE_URL } from "../api_config";
import { Link } from "react-router-dom";
import { AiTwotoneHeart, AiOutlineHeart } from "react-icons/ai";

import { CgProfile } from "react-icons/cg";

export default function HomeAllPartPref() {
  const { user, token, likedProfiles, setLikedProfiles, fetchUserData } =
    useContext(UserContext);
  const [partPref, setPartPref] = useState([]);

  useEffect(() => {
    const partPrefQuery = {
      id: user.user_id,
      gender: user.gender,
      membership: user.pay_membership,
      age: user.age,
      maritalStatus: user.marital_status,
      language: user.mother_tongue,
      edu: user.education,
      empType: user.employment_type,
      occu: user.occupation,
      income: user.income,
      religion: user.religion,
      caste: user.caste,
      kulam: user.kulam,
      star: user.star,
      raasi: user.raasi,
      height: user.height,
      weight: user.weight,
      bodyType: user.body_type,
      complexion: user.complexion,
      physicalStatus: user.pphysical_status,
    };
    axios
      .get(
        `${API_BASE_URL}/api/part-pref`,
        {
          params: partPrefQuery,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (Array.isArray(res.data)) {
          setPartPref(res.data);
        }
      })
      .catch((err) => {});
  }, [user]);

  const isProfileLiked = (userId) => {
    return likedProfiles !== undefined && likedProfiles.includes(userId);
  };

  const handleLikeDislike = (userId) => {
    if (isProfileLiked(userId)) {
      // Dislike the profile
      const updatedLikedProfiles = likedProfiles.filter((id) => id !== userId);
      setLikedProfiles(updatedLikedProfiles);
      axios
        .put(
          `${API_BASE_URL}/api/dislike-profile/${userId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          }
        )
        .then((res) => {
          fetchUserData();
        })
        .catch((error) => {
          // Handle error if needed
        });
    } else {
      // Like the profile
      const updatedLikedProfiles = [...likedProfiles, userId];
      setLikedProfiles(updatedLikedProfiles);
      axios
        .put(
          `${API_BASE_URL}/api/update-like-profiles`,
          { likedProfiles: updatedLikedProfiles },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          }
        )
        .then((res) => {
          fetchUserData();
        })
        .catch((error) => {
          // Handle error if needed
        });
    }
  };

  const renderPartPref = () => {
    return partPref.map((prof, i) => (
      <li className="profile-total-matches-item" key={i}>
        <div className="profile-total-match-blur">
          <div className="prof-total-match-cont">
            {prof.filename === null ? (
              <CgProfile className="prof-total-matches-img" />
            ) : (
              <img
                src={`${API_BASE_URL}/uploads/` + prof.filename}
                alt={`${prof.first_name}`}
                className="prof-total-matches-img"
              />
            )}
            <div className="prof-total-match-details">
              <h3>
                {prof.first_name} {prof.last_name}
              </h3>
              <p>age: {prof.age}</p>
              <p>education: {prof.education}</p>
              <p>occupation: {prof.occupation}</p>
              <p>
                {prof.cityName}, {prof.stateName}, {prof.countryName}
              </p>
            </div>
          </div>
        </div>
        <div className="match-intrst-cont-btns">
          {isProfileLiked(prof.user_id) ? (
            <AiTwotoneHeart
              className="match-intrst-btn"
              color="red"
              size={35}
              onClick={() => handleLikeDislike(prof.user_id)}
            />
          ) : (
            <AiOutlineHeart
              className="match-intrst-btn"
              color="white"
              size={35}
              onClick={() => handleLikeDislike(prof.user_id)}
            />
          )}
          <Link
            to={"/view-profile"}
            state={{ userId: prof.user_id }}
            className="total-match-view-prof-link"
          >
            View Profile
          </Link>
        </div>
      </li>
    ));
  };

  return (
    <div className="prof-daily-recom-container">
      <div className="prof-total-matches-heading-cont">
        <div className="prof-total-matches-heading-content">
          <h3 className="prof-daily-recom-heading">Partner Prefernces</h3>
          <ul className="prof-daily-recom-lists">{renderPartPref()}</ul>
        </div>
      </div>
    </div>
  );
}
